module.exports = __webpack_public_path__ + "img/down_button.dfd68da5.png";